export const annotationLayerDefinition = {
    geometryType: 'esriGeometryPoint',
    objectIdField: 'uniqueId',
    extent: {
        xmin: -180,
        ymin: -84.24316865399999,
        xmax: 180,
        ymax: 90,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'featureid',
            type: 'esriFieldTypeInteger',
            alias: 'featureid',
            editable: true,
            nullable: true
        },
        {
            name: 'featuretype',
            type: 'esriFieldTypeString',
            alias: 'featuretype',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'featuresubtype',
            type: 'esriFieldTypeInteger',
            alias: 'featuresubtype',
            editable: true,
            nullable: true
        },
        {
            name: 'rotation',
            type: 'esriFieldTypeDouble',
            alias: 'rotation',
            editable: true,
            nullable: true
        },
        {
            name: 'visible',
            type: 'esriFieldTypeString',
            alias: 'visible',
            editable: true,
            nullable: true,
            length: 5
        },
        {
            name: 'attribute1',
            type: 'esriFieldTypeString',
            alias: 'attribute1',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'attribute2',
            type: 'esriFieldTypeString',
            alias: 'attribute2',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'attribute3',
            type: 'esriFieldTypeString',
            alias: 'attribute3',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'attribute4',
            type: 'esriFieldTypeString',
            alias: 'attribute4',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'attribute5',
            type: 'esriFieldTypeString',
            alias: 'attribute5',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'attribute6',
            type: 'esriFieldTypeString',
            alias: 'attribute6',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'attribute7',
            type: 'esriFieldTypeString',
            alias: 'attribute7',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'attribute8',
            type: 'esriFieldTypeString',
            alias: 'attribute8',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'attribute9',
            type: 'esriFieldTypeString',
            alias: 'attribute9',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'attribute10',
            type: 'esriFieldTypeString',
            alias: 'attribute10',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'labelexpression',
            type: 'esriFieldTypeString',
            alias: 'labelexpression',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'x',
            type: 'esriFieldTypeDouble',
            alias: 'x',
            editable: true,
            nullable: true
        },
        {
            name: 'y',
            type: 'esriFieldTypeDouble',
            alias: 'y',
            editable: true,
            nullable: true
        },
        {
            name: 'enlargementids',
            type: 'esriFieldTypeString',
            alias: 'enlargementids',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'enlargementid',
            type: 'esriFieldTypeInteger',
            alias: 'enlargementid',
            editable: true,
            nullable: true
        },
        {
            name: 'childtype',
            type: 'esriFieldTypeString',
            alias: 'childtype',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'childid',
            type: 'esriFieldTypeInteger',
            alias: 'childid',
            editable: true,
            nullable: true
        },
        {
            name: 'parentid',
            type: 'esriFieldTypeInteger',
            alias: 'parentid',
            editable: true,
            nullable: true
        },
        {
            name: 'hiddenonenlargements',
            type: 'esriFieldTypeString',
            alias: 'hiddenOnEnlargements',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'rotationdms',
            type: 'esriFieldTypeString',
            alias: 'rotationdms',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'labelproperties',
            type: 'esriFieldTypeString',
            alias: 'labelproperties',
            editable: true,
            nullable: true,
            length: 1024
        }
    ]
};
